import { Button, Layout, Menu, theme } from "antd";
import { Outlet, Link } from "react-router-dom";
import "./LayoutClass.css";
import { Header, Content } from "antd/es/layout/layout";

const LayoutClass = (props) => {

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const items = [];
    items.push({
        key: 1,
        label: <Link to='/login'>Login</Link>
    });
    items.push({
        key: 2,
        label: <Link to='/'>Main</Link>
    });
    items.push({
        key: 3,
        label: <Link to='/stats'>Stats</Link>
    });
    items.push({
        key: 4,
        label: <Link to='/userAdmin'>Add Ingredients</Link>
    });
    items.push({
        key: 5,
        label: localStorage.getItem("roleStrength") >= 10 && <Link to='/admin'>Admin</Link>
    });

    return (
        <>
            <Layout>
                <Header style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="logo">LOGO</div>
                    <Menu
                        className="topMenu"
                        theme="dark"
                        mode="horizontal"
                        items={items}
                        style={{ flex: 1, minWidth: 0, gap: '20px' }}
                    />
                </Header>
                <Content style={{ padding: '0 48px', minHeight: 280 }}>
                    <div style={{
                        background: colorBgContainer,
                        minHeight: 280,
                        padding: 24,
                        borderRadius: borderRadiusLG
                    }}>
                        {props.content}
                    </div>
                </Content>
            </Layout >
        </>
    )
};

export default LayoutClass;
